'use client';

import { Alert, AlertBody, Heading, LayoutLinelengthContainer, TextPassage } from '@petsmart-ui/sparky';
import { useEffect } from 'react';

import { trackError } from '@libs/analytics';

import { useNotificationStore } from '@/shared/notifications';

import './styles.scss';

export const ErrorAlert = () => {
    const notice = useNotificationStore(state => state.current);
    const isError = notice?.type === 'error';

    useEffect(() => {
        if (isError) {
            trackError('PDP', notice.message);
            window.scrollTo({ top: 1, behavior: 'smooth' });
        }
    }, [notice?.id, notice?.type, notice?.message, isError]);

    if (!isError) return null;

    return (
        <div className="error-block" data-testid="test-error-block">
            <Alert iconName="exclamation-circle-fill" variant="error">
                <AlertBody>
                    <LayoutLinelengthContainer>
                        <Heading size="body-bold" tagName="h2">
                            {notice.title}
                        </Heading>
                    </LayoutLinelengthContainer>
                    <TextPassage>
                        <p>{notice.message}</p>
                    </TextPassage>
                </AlertBody>
            </Alert>
        </div>
    );
};
